import { Colors } from '../../../themes';
import { camelToKebab } from './camel-to-kebab';

export const colorsToKebab = (colors: Colors): Record<string, string> =>
  Object.keys(colors).reduce((acc: Record<string, string>, cur: string) => {
    acc[camelToKebab(cur)] = colors[cur];
    return acc;
  }, {});
